// Module
var code = `<template>
  <div click.trigger="onDeleteClicked()" if.bind="params.data.IsEditable != null || params.data.isEditable != null ? (params.data.IsEditable || params.data.isEditable) : true">
    <a class="grid-icon" router-ignore>
      <mdc-icon if.bind="params.data != null" aria-hidden="true">delete</mdc-icon>
    </a>
  </div>
  <!--  <a><i click.delegate="onDeleteClicked()" class="fas fa-trash-alt fa-1-5x" aria-hidden="true"></i></a>-->
</template>
`;
// Exports
export default code;